/* eslint-disable max-len */
import React, { useState, useEffect } from "react"
import FormatDateString from '../../../../../CommonMethods/FromatDateString';
import { GetBranchId } from "../../../../../CommonMethods/GetBranchId";
import { dataService } from "../../../../../services/data.services";
import { ShimmerTitle } from 'react-shimmer-effects'

export default function AcademicDetails({studentDetails}){
    let branch_name=""
    branch_name=JSON.parse(localStorage.getItem("branch_details"))?.name

    const [studentAyList, setStudentAyList] =useState([])
    const [promotionHistLoading, setpromotionHistLoading] = useState(false)

    const getAcademicYears = async () => {
        try {
            setpromotionHistLoading(true);
            const branch_id = await GetBranchId()
            let endpoint1 = `students/list-ay-class?branch_id=${branch_id}&group_by_academic=false&student_id=` + (studentDetails?._id);
            const response1 = await dataService.GetAPI(endpoint1);

            const studentAyList = response1?.data?.data?.data || [];
            setStudentAyList(studentAyList)
            setpromotionHistLoading(false)
        }
        catch (error) {
            console.log(error);
            setpromotionHistLoading(false)
            //setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally{
            setpromotionHistLoading(false)
        }
        console.log('promotionHistLoading',promotionHistLoading)
    }

    useEffect(() => {
        if (studentDetails?.student_id) {
            getAcademicYears();
        }
    }, [studentDetails]);

    return (
        <>
            <div
                class="transition-opacity duration-150 ease-linear data-[te-tab-active]:block px-2.5 mt-5"
                id="tabs-acadamicDetails"
                role="tabpanel"
                aria-labelledby="tabs-acadamicDetails-tab"
            >
                <div class="w-[800px] mx-auto">
                    <div class="w-full border border-[#e7e7e7] rounded p-4 mb-4">
                        <div class="flex">
                            <div class="w-1/2 pr-6">
                                <div class="">
                                    <p class="text-f7 font-semibold text-[#031624] w-full pb-4">
                                        Current AY Details
                                    </p>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[75%] px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">
                                                Branch Name
                                            </p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p
                                                title={branch_name}
                                                class="text-f7 font-semibold text-[#031624] w-full break-words more-lines"
                                            >
                                                {branch_name}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[75%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">
                                                Academic Year
                                            </p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">
                                                {studentDetails?.academic_year?.name || "-"}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1 mb-4">
                                        <div class="w-[75%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">
                                                Class
                                            </p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">
                                                {studentDetails?.classes?.class_name || "-"}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="flex -mx-1">
                                        <div class="w-[75%]  px-1">
                                            <p class="text-f7 font-normal text-[#031624] w-full">
                                                Section
                                            </p>
                                        </div>
                                        <div class="w-full px-1">
                                            <p class="text-f7 font-semibold text-[#031624] w-full break-words">
                                                {studentDetails?.sections?.section_name || "-"}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-1/2 border-l border-[#e7e7e7]">
                                <div class="w-full flex h-full">
                                    <div class="pl-3 pb-3 pr-[23px] w-1/2">
                                        <p class="text-f7 font-semibold text-[#031624] w-full pb-[18px]">
                                            Mandatory Subjects
                                        </p>
                                        {studentDetails?.mandatory_subject?.length !== 0 ? <ul class="pl-2.5">
                                            {studentDetails?.mandatory_subject?.map((item) => (
                                                <li key={item?.subject_id} class="text-f7 font-normal text-[#031624] min-w-[150px] break-all 2xl:w-full mb-3">
                                                    {item?.subject_name}
                                                </li>
                                            ))}
                                        </ul> : <ul class="pl-2.5">
                                            <ul class="pl-2.5 ">
                                                <li key="1" class="text-f7 font-semibold text-[#031624] w-full mb-3 ml-[42px] ">
                                                    -
                                                </li>
                                            </ul>
                                        </ul>}
                                    </div>
                                    <div class="px-3 pb-3 w-1/2 border-l border-[#e7e7e7]">
                                        <p class="text-f7 font-semibold text-[#031624] w-full pb-[18px]">
                                            Optional Subjects
                                        </p>
                                        {studentDetails?.optional_subject?.length !== 0 ? <ul class="pl-2.5">
                                            <ul class="">
                                                {studentDetails?.optional_subject?.map((item) => (
                                                    <li key={item?.subject_id} class="text-f7 font-normal text-[#031624] min-w-[135px] 2xl:w-full break-all mb-3">
                                                        {`${item?.subject_name}${(item?.amount !== "" && item?.amount !== undefined && item?.amount !== null) ? `(${item?.amount})` : ''}`}
                                                    </li>
                                                ))}
                                            </ul>
                                        </ul>:<ul class="pl-2.5">
                                            <ul class="pl-2.5 ">
                                                <li key="1" class="text-f7 font-semibold text-[#031624] w-full mb-3 ml-[42px] ">
                                                    -
                                                </li>
                                            </ul>
                                        </ul>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pt-4 w-[800px] mx-auto bg-white mb-10 grid">
                <h2 className="text-[18px] font-semibold mb-3">Academic Promotion History</h2>
                {promotionHistLoading && <>
                    <ul className="space-y-3 pl-6 relative">
                        <li className="relative flex items-start">
                            <span className="absolute -left-4 top-2 w-5 h-5 shadow-s13 bg-white border border-gray-400 rounded-full flex items-center justify-center">
                                <span className="rounded-full" style={{ height: "0.6rem", width: "0.6rem", 'background-color':'#577fc1' }}></span>
                            </span>
                            <p className="timelinebox ShimmerTitle">
                                <p className="text-2xl font-bold text-[#031624]">
                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="!mb-0 w-[70px]"/>
                                    <ShimmerTitle line={1} gap={6} variant="secondary" className="!mb-0 w-[150px] mt-2"/>
                                </p>
                            </p>
                        </li>
                    </ul>
                </>
                }
                {Array.isArray(studentAyList) && studentAyList.length > 0 && !promotionHistLoading && (
                    <ul className="space-y-3 pl-6 relative">
                        {(studentDetails.status == 'transferred' || studentDetails.status == 'terminated') &&
                            <>
                                <li className="relative flex items-start">
                                    <div className="absolute left-[-0.45rem] top-6 h-full w-0.5 bg-gray-300"></div>
                                    <span className="absolute -left-4 top-2 w-5 h-5 shadow-s13 bg-white border border-gray-400 rounded-full flex items-center justify-center">
                                        <span className="rounded-full" style={{ height: "0.6rem", width: "0.6rem", 'background-color':'#577fc1' }}></span>
                                    </span>
                                    <p className="timelinebox">
                                        <span className="inline-grid">
                                            <span className="font-[12px] text-gray-500">{FormatDateString(studentDetails.transferred_at || studentDetails.terminated_at)}</span>
                                            <span>{studentDetails.status == 'transferred'?"Transferred Out":"Terminated"} <span className="font-[12px] text-gray-500 italic">- {studentDetails.transferred_by || studentDetails.terminated_by}</span></span>
                                        </span>
                                    </p>
                                </li>
                            </>}
                        
                        {studentAyList.map((entry, index) => {
                            const prevEntry = studentAyList[index + 1]; // Next entry in time
                            let actionText = "Admitted to";

                            if (prevEntry) {
                                if (
                                    prevEntry.academic_year_id === entry.academic_year_id &&
                                    prevEntry.class_id === entry.class_id &&
                                    prevEntry.section_id !== entry.section_id
                                ) {
                                    actionText = "Transferred to";
                                } else {
                                    actionText = "Promoted to";
                                }
                            }

                            return (
                                <li key={entry._id} className="relative flex items-start">
                                    {/* Vertical Line */}
                                    {index !== studentAyList.length - 1 && (
                                        <div className="absolute left-[-0.45rem] top-6 h-full w-0.5 bg-gray-300"></div>
                                    )}
                                    {/* Circle Indicator */}
                                    <span className="absolute -left-4 top-2 w-5 h-5 shadow-s13 bg-white border border-gray-400 rounded-full flex items-center justify-center">
                                        <span className="rounded-full" style={{ height: "0.6rem", width: "0.6rem", 'background-color':'#577fc1' }}></span>
                                    </span>
                                    <p className="timelinebox">
                                        <span className="inline-grid">
                                            <span className="font-[12px] text-gray-500">{FormatDateString(entry.created_at)}</span>
                                            <span>{` ${actionText} ${entry.academic_year.name} ${entry.class_name}, ${entry.section_name}`}
                                                <span className="font-[12px] text-gray-500 italic"> - {entry.created_by}</span>
                                            </span>
                                        </span>
                                    </p>
                                </li>
                            );
                        })}
                    </ul>

                )}
                
            </div>

        </>



    );
}